import React from 'react'
import './Programs.css'
import { programsData } from '../../data/programsData'
import RightArrow from '../../assets/rightArrow.png'
import { Link } from 'react-scroll'

const Programs = () => {
  return (
    <div className='Programs' id='programs'>
      {/* Header */}
      <div className="programs-header">
        <span className='stroke-text'>Explore our</span>
        <span> Programs</span>
        <span className='stroke-text'> to Shape You</span>
      </div>

      {/* Program Cards */}
      <div className="program-categories">
        {programsData.map((program, index) => (
          <div className="category" key={index}>
            <Link 
              to="join-us" 
              smooth={true} 
              className="category-link"
            >
              <div className="category-content">
                {program.image}
                <span>{program.heading}</span>
                <span>{program.details}</span>
                <div className="join-now">
                  <span>Join Now</span>
                  <img src={RightArrow} alt="" />
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Programs